import clsx from 'clsx';
import Card from './Card';

/**
 * One bordered card split into equal columns by hairline dividers — the
 * dashboard mockups' "stat strip" pattern (Active AUM | Total investors |
 * Pending KYC | Open tickets all inside a single card), as opposed to N
 * separate elevated cards. Used by both the admin Overview and investor
 * Dashboard so the two read as the same design language rather than two
 * different card treatments for the same kind of content.
 */
export default function StatStrip({ columns = 4, className, children }) {
  return (
    <Card className={clsx('!p-0 overflow-hidden', className)}>
      <div
        className={clsx(
          'grid divide-y sm:divide-y-0 divide-x divide-border',
          columns === 3 ? 'grid-cols-2 sm:grid-cols-3' : 'grid-cols-2 sm:grid-cols-4'
        )}
      >
        {children}
      </div>
    </Card>
  );
}

export function StatStripItem({ className, children }) {
  return <div className={clsx('p-5', className)}>{children}</div>;
}
